import { Button } from "primereact/button"
import Next from "./next"
import Previous from "./previous"
import PropTypes from "prop-types"
import { saveAs } from "file-saver"
import { useState, useContext } from "react"
import { errorMessages } from "../types/messages"
import { useNavigate } from "react-router-dom"
import { Dialog } from "primereact/dialog"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import gpraStyles from "../../../styles/Participant-GPRA.module.css"
import { gpraUrl } from "../../../config/microservicesUrls"
import axios from "axios"
import { UserContext } from "../../../context/userContext"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"

const CustomToolBar = (props) => {
  const { nextForm, prevForm, saveData, showFinish, toast, showCancel } = props
  const [cancelConfirmation, setCancelConfirmation] = useState(false)

  const navigate = useNavigate()
  const {
    cancellingInterview,
    handleCancellingInterview,
    pdfDownloading,
    handlePdfDownloading,
    handleSubmitPost,
    interview,
    interviewType,
    handleActiveIndex,
    loadNext,
    loadPrev,
    handleLoadFinish,
    loadFinish,
    summary,
    handleInterviewType,
    setAdministrativeInterview,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  // eslint-disable-next-line no-unused-vars
  const download = () => {
    handlePdfDownloading(true)
    axios({
      method: "get",
      url: `${gpraUrl()}${endpoints.GET_PDF}`,
      responseType: "blob",
      params: {
        gpra_participant_uuid: interview.recordManagement.gpra_participant_uuid,
        interview_type: interviewType,
        membership_uuid: interview.recordManagement.gpra_membership_uuid,
        organization_uuid: interview.recordManagement.organization_uuid,
      },
      headers: { Authorization: `Bearer ${userCtx.tokenGpra}` },
    })
      .then((response) => {
        if (response.status !== 500) {
          var file = new File(
            [response.data],
            `${interview.recordManagement.gpra_participant_id}.pdf`,
            {
              type: "application/pdf;charset=utf-8",
            }
          )
          handlePdfDownloading(false)
          saveAs(file)
        } else {
          handlePdfDownloading(false)
          showMessage(false, errorMessages.pdfError, toast)
        }
      })
      .catch(() => {
        handlePdfDownloading(false)
        showMessage(false, errorMessages.pdfError, toast)
      })
  }
  const cancel = () => {
    handleSubmitPost(endpoints.CANCEL_INTERVIEW, {
      gpra_membership_uuid:
        interview[INTERVIEW_SECTIONS.RECORD_MGMT].gpra_membership_uuid,
      gpra_interview_type: interviewType,
      gpra_participant_uuid:
        interview[INTERVIEW_SECTIONS.RECORD_MGMT].gpra_participant_uuid,
    }).then((response) => {
      if (response.status === 200 || response.status === 201) {
        handleInterviewType("")
        navigate("/participant/gpra-forms")
        handleActiveIndex(0)
        handleCancellingInterview(false)
        setAdministrativeInterview(undefined)
      }
    })
  }
  const confirmationDialogFooter = (
    <>
      <Button
        type="button"
        label="No"
        icon="pi pi-times"
        onClick={() => setCancelConfirmation(false)}
        className="p-button-text"
      />
      <Button
        type="button"
        label="Yes"
        icon="pi pi-check"
        onClick={() => {
          setCancelConfirmation(false)
          cancel()
        }}
        className="p-button-text"
        autoFocus
      />
    </>
  )
  return (
    <>
      {showFinish && (
        <Button
          disabled={pdfDownloading || cancellingInterview || loadFinish}
          label="Download PDF"
          icon={!pdfDownloading ? "pi pi-download" : "pi pi-spin pi-spinner"}
          className={gpraStyles.mr1}
          onClick={download}
        />
      )}
      {showCancel && !summary && !editMode && (
        <Button
          disabled={
            cancellingInterview ||
            pdfDownloading ||
            loadNext ||
            loadPrev ||
            loadFinish
          }
          label="Cancel"
          icon={!cancellingInterview ? "pi pi-times" : "pi pi-spin pi-spinner"}
          className={gpraStyles.cancelButton}
          onClick={() => {
            setCancelConfirmation(true)
          }}
        />
      )}
      {showFinish && !summary && (
        <Button
          disabled={cancellingInterview || pdfDownloading}
          label="Finish"
          icon={!loadFinish ? "pi pi-times" : "pi pi-spin pi-spinner"}
          className={gpraStyles.mr1}
          onClick={() => {
            handleLoadFinish(true)
            saveData()
          }}
        />
      )}
      {prevForm && !summary && (
        <Previous
          disabled={
            cancellingInterview ||
            pdfDownloading ||
            loadNext ||
            loadPrev ||
            loadFinish
          }
          saveData={saveData}
        />
      )}
      {nextForm && (
        <Next
          disabled={
            cancellingInterview || pdfDownloading || loadNext || loadPrev
          }
          saveData={saveData}
        />
      )}
      <Dialog
        header="Cancel Interview"
        visible={cancelConfirmation}
        onHide={() => setCancelConfirmation(false)}
        style={{ width: "350px" }}
        modal
        footer={confirmationDialogFooter}
      >
        <div className={gpraStyles.cancelDialogText}>
          <i
            className="pi pi-exclamation-triangle"
            style={{ fontSize: "2rem" }}
          />
          <span className={gpraStyles.ml1}>
            Are you sure you want to proceed?
          </span>
        </div>
      </Dialog>
    </>
  )
}

CustomToolBar.propTypes = {
  saveData: PropTypes.func,
  nextForm: PropTypes.bool,
  prevForm: PropTypes.bool,
  showFinish: PropTypes.bool,
  toast: PropTypes.object,
  showCancel: PropTypes.bool,
}
CustomToolBar.defaultProps = {
  showFinish: false,
  showCancel: true,
}
export default CustomToolBar
